import React from 'react';
import {
  ConnectWallet,
  metamaskWallet,
  trustWallet,
  coinbaseWallet,
  walletConnect,
  rainbowWallet,
  phantomWallet,
  okxWallet,
} from '@thirdweb-dev/react';
import turtleShell from '../../images/button/turtleshell.png';

const TurtleWalletButton = ({ title, fontSize = '1rem', padding = '0.6rem 1.2rem', marginTop }) => (
  <ConnectWallet
    theme="dark"
    modalTitle="Choose Your Wallet"
    modalSize="wide"
    btnTitle={title}
    switchToActiveChain={true}
    className="turtle-button"
    style={{
      backgroundImage: `url(${turtleShell})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      color: '#fff',
      fontWeight: 'bold',
      fontSize,
      padding,
      border: 'none',
      borderRadius: '0.75rem',
      cursor: 'pointer',
      textShadow: '1px 1px 2px rgba(0, 0, 0, 0.6)',
      transition: 'filter 0.3s ease',
      marginTop: marginTop || 0,
    }}
    onMouseEnter={(e) => (e.target.style.filter = 'brightness(1.1)')}
    onMouseLeave={(e) => (e.target.style.filter = 'none')}
    supportedWallets={[
      metamaskWallet(),
      trustWallet(),
      coinbaseWallet(),
      walletConnect(),
      rainbowWallet(),
      phantomWallet(),
      okxWallet(),
    ]}
  />
);

export default TurtleWalletButton;
